import {createSelector} from 'reselect';
import {RootState} from '../store/store';
import {getYYYYMMDD} from "../../utils/dateUtils";

const productsSelector = (state: RootState) => state.products;

export const getProductList = createSelector(
  [productsSelector],
  (state) => state.list
);

/**
 * Productの並び替えのパターン.
 * selectProductsByFilterで使いたい
 */
export type ProductOrder = 'time' | 'expensive' | 'inexpensive' | 'stocks';
/**
 * category, keyword, orderに合致するproductsを返す
 * @param state
 * @param category DBのcategoriesコレクションに保存されているデータのID(フィールドにある方)
 * @param keyword 任意の
 * @param order
 * @param receiveDate 受取日に在庫があるものをフィルターする. undefinedならフィルターしない
 */
export const selectProductsByFilter = (
  state: RootState,
  category: string,
  keyword: string,
  order: string,
  receiveDate: Date | undefined
) => {
  if (receiveDate === undefined) return [];

  const yyyyMMdd = getYYYYMMDD(receiveDate);
  const products = state.products.list;
  const role = state.users.role;

  // FIXME: keywordは配列にした方がいいかも
  return products
    .filter(p =>
      (category === '' || p.category === category) &&
      (keyword === '' || p.name.includes(keyword)) &&
      (role === 'admin' || !p.status || p.status === 'show'))
    // .sort((a, b) => {
    //   if (
    //     a.stocks[yyyyMMdd] - a.ordered[yyyyMMdd] === 0 &&
    //     b.stocks[yyyyMMdd] - b.ordered[yyyyMMdd] !== 0
    //   )
    //     return 1;
    //   else if (
    //     a.stocks[yyyyMMdd] - a.ordered[yyyyMMdd] !== 0 &&
    //     b.stocks[yyyyMMdd] - b.ordered[yyyyMMdd] === 0
    //   )
    //     return -1;
    //   else return a.updated_at < b.updated_at ? 1 : -1;
    // })
    .sort((a, b) => {
      return a.sort_order - b.sort_order
    })
    .sort((a, b) => {
      // 受取日未指定の場合はソートしない
      if (receiveDate === undefined) return 1;
      const aHasStock = a.stocks[yyyyMMdd] - a.ordered[yyyyMMdd] > 0;
      const bHasStock = b.stocks[yyyyMMdd] - b.ordered[yyyyMMdd] > 0;
      // XOR
      if (aHasStock === bHasStock) return 1;
      return aHasStock ? -1 : 1;
    });
}

/**
 * Productの読み込み状況のStatusを返す
 * @param state
 */
export const selectProductStatus = (state: RootState) => state.products.status;

/**
 * 全ての Product を返す
 * @param state
 */
export const selectProducts = (state: RootState) => state.products.list;
